﻿define(['languageControl', 'navigationControl', 'toolbarControl', 'mixpanelControl'], function() {
    'use strict';
});
